import ajax from '../http/ajax'

/**
 * 优惠券详情接口
 * @param {*} params 参数
 * @return 略
 */
export const getCouponInfo = params => {
    return ajax.get('getCouponInfo', params)
}

/**
 * 领取优惠券
 * @param {*} params 参数
 * @return 略
 */
export const getCoupon = params => {
    return ajax.get('getCoupon', params)
}

/**
 * bd优惠券购买-生成订单
 * @param {*} params 参数
 * @return 略
 */
export const createBdCouponOrder = params => {
    return ajax.post('createBdCouponOrder', params)
}

/**
 * bd优惠券-可用券门店列表
 * @param {*} params 参数
 * @return 略
 */
export const getBdCouponUseSstoreList = params => {
    return ajax.get('getBdCouponUseSstoreList', params)
}
